var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState, memo } from "react";
import { useDispatch } from "react-redux";
import { HDSButton } from "@here/hds-react-components/Button";
import { REQUEST_UPDATE_BUTTON } from "../../constants";
import { AnnotationWithFloorPlans, UploadFloorPlansOnly, ConfirmBody, } from "./components";
import { setAnnotationPresent, setDiscardAllAnnotations, } from "../../../../store/reducers/jsMapSlice";
import { processDraftPayload } from "../../../../api/venuesList";
import { getUserAnnotateInfo } from "../../helper";
import { useUserInfo } from "../../../../hooks";
import { DRAFT_TYPE, NOTIFICATION_VARIANT, } from "../../../../store/common/constants";
import { createDraftForAnnotation, handleAttachment, handleNotification, } from "./helper";
import { useGlobalVenueState } from "../../../../hooks";
import { ConfirmDailog } from "../../../../generic-components";
import { setVenue } from "../../../../store/reducers/venueSlice";
import { CONFIRM_DAILOG_HEADER } from "./constant";
export var MapNavBar = memo(function (props) {
    var annotationPresent = props.annotationPresent, venue = props.venue, isFloorPlansOnly = props.isFloorPlansOnly, onSourceOnlyClick = props.onSourceOnlyClick, showEntryModal = props.showEntryModal;
    var _a = useState(false), showModal = _a[0], setShowModal = _a[1];
    var _b = useState(false), isLoading = _b[0], setLoading = _b[1];
    var dispatch = useDispatch();
    var _c = useState([]), files = _c[0], setFiles = _c[1];
    var userInfo = useUserInfo();
    var updateCurrentVenue = useGlobalVenueState().updateCurrentVenue;
    var draftPayloadParams = {
        venue: venue,
        userInfo: userInfo,
        draftType: DRAFT_TYPE.UPDATE_ORDER,
    };
    var setDraftRequest = processDraftPayload(draftPayloadParams).setDraftRequest;
    var handleModal = function (show) {
        setShowModal(show);
    };
    var handleIsLoading = function (isLoading) {
        setLoading(isLoading);
    };
    var handleFileChange = function (file) {
        setFiles(file);
    };
    var handleOnSubmit = function (attachmentDetails) { return __awaiter(void 0, void 0, Promise, function () {
        var isSubmitSuccess, annotationList, requestPayload, orderResponse, draftHrn, attachmentRes, e_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    isSubmitSuccess = false;
                    setLoading(true);
                    annotationList = isFloorPlansOnly
                        ? { notes: attachmentDetails.description }
                        : getUserAnnotateInfo(attachmentDetails.description);
                    requestPayload = setDraftRequest(annotationList);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, createDraftForAnnotation(userInfo.token, requestPayload)];
                case 2:
                    orderResponse = (_b.sent());
                    if (orderResponse === null || orderResponse === void 0 ? void 0 : orderResponse.status) {
                        isSubmitSuccess = true;
                        draftHrn = (_a = orderResponse.data) === null || _a === void 0 ? void 0 : _a.draftHrn;
                        attachmentRes = {
                            token: userInfo.token,
                            hrn: draftHrn,
                            files: attachmentDetails.files,
                        };
                        //This will update the venues in current map details and other tab listing
                        updateCurrentVenue(venue);
                        setLoading(false);
                        dispatch(setDiscardAllAnnotations(true));
                        dispatch(setAnnotationPresent(false));
                        handleNotification("SUCCESS", NOTIFICATION_VARIANT.CONFIRM);
                        //TO-DO: keep the user on map details page,
                        // but the user should not be allowed to annotate further after a successful annotation request
                        dispatch(setVenue(null));
                        //this will call the attachment api
                        handleAttachment(attachmentRes);
                        return [2 /*return*/, isSubmitSuccess];
                    }
                    return [3 /*break*/, 5];
                case 3:
                    e_1 = _b.sent();
                    handleNotification("FAILURE", NOTIFICATION_VARIANT.ERROR);
                    setLoading(false);
                    return [2 /*return*/, isSubmitSuccess];
                case 4:
                    setFiles([]);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/, isSubmitSuccess];
            }
        });
    }); };
    var callbacks = {
        handleIsLoading: handleIsLoading,
        handleModal: handleModal,
        handleOnSubmit: handleOnSubmit,
        handleFileChange: handleFileChange,
        onSourceOnlyClick: onSourceOnlyClick,
        showEntryModal: showEntryModal,
        setShowModal: setShowModal,
    };
    var options = {
        isLoading: isLoading,
        showModal: showModal,
        isFloorPlansOnly: isFloorPlansOnly,
        files: files,
    };
    //Loader while draft api call
    if (isLoading) {
        var Processing = (_jsx(ConfirmDailog, { header: CONFIRM_DAILOG_HEADER, renderBody: function () { return _jsx(ConfirmBody, {}); } }));
        return Processing;
    }
    return (_jsxs(_Fragment, { children: [isFloorPlansOnly ? (_jsx(UploadFloorPlansOnly, { options: options, callbacks: callbacks })) : (_jsx(AnnotationWithFloorPlans, __assign({}, props, { options: options, callbacks: callbacks }))), _jsx("div", __assign({ "data-testid": "js-menu-bar", className: "menuBar" }, { children: annotationPresent && (_jsx("div", __assign({ onClick: function () { return setShowModal(true); } }, { children: _jsx(HDSButton, __assign({ variant: "primary", size: "small" }, { children: REQUEST_UPDATE_BUTTON })) }))) }))] }));
});
